
import {defineComponent, PropType} from "vue"
import {Excursion} from "@/services/excursions/types";

export default defineComponent({
  props: {
    excursion: {
      required: true,
      type: Object as PropType<Excursion>
    }
  },
  computed: {
    allFeatures() {
      const {aim, duration, type} = this.excursion
      return [aim, duration, type].filter(feature => feature !== null)
    }
  }
})
